import { Identifier } from 'react-admin';

export const enum UserEntityPermissionsNames {
  Gateway = 'Gateway',
  MerchantAccount = 'MerchantAccount',
  MerchantCredentials = 'MerchantCredentials',
}

export type UserEntityPermission = {
  id?: number;
  entity: UserEntityPermissionsNames;
  rowId: number;
  user: Identifier | null;
  expiredAt: number | null;
};
